import React from "react";
import TransmissaoService from "../../services/TransmissaoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaTransmissao extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: TransmissaoService,
            labels: {
                title: 'Lista de Transmissão(ões)',
                btnNewRegister: 'Transmissão',
            },
            keyItem: 'idTransmissao',
            urlForm: '/CadTransmissao',
            itensFilter: ["idTransmissao", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idTransmissao}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}